import { FunctionalComponent, h } from 'preact';
import styled from 'styled-components';

const H1 = styled.div`
  color: ${({ theme }) => theme.ui.text.color};
  font-size: ${({ theme }) => theme.typography.size.large};
  font-weight: ${({ theme }) => theme.typography.weight.bold};
  margin: 0;
`;

const Heading: FunctionalComponent = ({ children }) => {
  return (
    <H1 role="heading" aria-level={1}>
      {children}
    </H1>
  );
};

export default Heading;
